import {LoginHome} from "../index";
import ButtonMenu from "../../app/buttonMenu/buttonMenu";
import React, {useRef} from "react";
import {useIntl} from "react-intl";
import logo from '../../../images/logos/squadDiskHR.png'

function LoginPage({}) {

    const intl = useIntl();

    const loginHome = useRef();

    return (
        <div className="container" style={{
            maxWidth: "760px",
        }}>
            <div className="col-12 d-flex align-items-center mb-4 mt-4">
                <img src={logo} width="100%" className="App-logo" alt="logo"/>
            </div>
            <ButtonMenu text={intl.formatMessage({id: "users.login.log-in"})} classIcon="fa-solid fa-right-to-bracket"
                        verified={true} className="mb-4" onClick={() => loginHome.current.openModal()} forceBig={true}/>
            <ButtonMenu text={intl.formatMessage({id: "users.login.sign-up"})} classIcon={"fa-solid fa-user-plus"}
                        verified={true} className="mb-4" onClick={() => loginHome.current.openModal("signUp")}
                        forceBig={true}/>
            <LoginHome ref={loginHome}/>
        </div>
    )
}

export default LoginPage;
